module.exports = __webpack_public_path__ + "img/expired-logo.032b1aaa.png";